import trash01 from "../assets/trash01.svg";
import download02 from "../assets/download02.svg";
import file02 from "../assets/file02.svg";
import { FileEntity } from "@quantizr-engineering/common/types/file";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useFileService } from "../api/fileService";

interface DocumentsTableProps {
  files: FileEntity[];
}

const DocumentsTable = ({ files }: DocumentsTableProps) => {
  const navigate = useNavigate();
  const { fetchPdfContent } = useFileService();

  const handleLinkClick = (e: any, id: number) => {
    e.preventDefault();
    e.stopPropagation();
    if (id) {
      fetchPdfContent(id)
        .then((pdfContent: any) => {
          const blob = new Blob([pdfContent], { type: "application/pdf" });
          const url = URL.createObjectURL(blob);
          window.open(url, "_blank");
        })
        .catch((error: any) => {
          console.error("Error fetching PDF:", error);
        });
    } else {
      console.error("contractAgreementID is undefined");
    }
  };

  return (
    <div className="space-y-2 mt-2">
      {files.map((doc: FileEntity, index: number) => (
                <div
          key={index}
          className="flex justify-between items-center border border-transparent hover:border-gray-300 px-3 py-2 rounded-lg"
          onClick={() => navigate(`/documents/${doc.id}`)}
          onAuxClick={(e) => {
            e.preventDefault();
            window.open(`/documents/${doc.id}`, "_blank","noopener,noreferrer");
          }}
        >
          <div className="flex items-center gap-2">
            <img src={file02} alt="File" className="w-6 h-6" />

            <span className="text-sm font-medium text-[#48455B]">
              {doc.name}
            </span>
            <span className="text-xs text-gray-500">
              Added {doc.uploadedAt.toDateString()}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <button onClick={(e) => handleLinkClick(e, doc.id)}>
              <img
                src={download02}
                alt="Download"
                className="w-6 h-6 hover:bg-gray-100"
              />
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                toast.error("Deleting file failed. Contact Qz Support");
              }}
            >
              <img
                src={trash01}
                alt="Trash"
                className="w-6 h-6 hover:bg-gray-100"
              />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DocumentsTable;
